import { call, put } from 'redux-saga/effects'

import { handleUnAuthorizedError } from '../../../utils/saga.util'
import { getBlogDetailSucceed, requestFailure } from '../actions'
import { AxiosError } from 'axios'

export function* getBlogDetailSaga(
  blogApi: {
    getBlogDetail: (...args: any[]) => any
  },
  { payload: blogId }: { payload: string }
) {
  try {
    const { data } = yield call(blogApi.getBlogDetail, blogId)
    yield put(getBlogDetailSucceed(data))
  } catch (error: unknown) {
    if (error && typeof error === 'object' && 'isAxiosError' in error) {
      yield handleUnAuthorizedError(error as AxiosError)
      yield put(requestFailure(error))
    } else {
      yield put(requestFailure(error))
    }
  }
}
